import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["embedUrl"]

  connect() {
    const referrer = document.referrer
    if (referrer) {
      try {
        const url = new URL(referrer)
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          this.embedUrlTarget.value = referrer
        }
      } catch {
        // referrer is not a valid URL, leave fields empty
      }
    }
  }
}
